// TODO move to job dispatcher folder
export enum EventLevel {
  Unknown = 0,
  System = 4,
  Informational = 1,
  Warning = 2,
  Alert = 3
}

export const EventLevelMapping: Record<EventLevel, string> = {
  [EventLevel.Unknown]: '-- Select Type --',
  [EventLevel.Informational]: 'Informational',
  [EventLevel.Warning]: 'Warning',
  [EventLevel.Alert]: 'Alert',
  [EventLevel.System]: 'System'
};
